<div class="layout-container">
  <!-- Sidebar -->
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav 
      #drawer 
      mode="side" 
      opened="true"
      class="sidenav"
    >
      <!-- Professional Sidebar Header -->
      <div class="sidebar-header">
        <div class="logo-container">
          <div class="logo-text">
            <h2>Equidesk</h2>
            <span class="logo-subtitle">Admin Panel</span>
          </div>
        </div>
      </div>

      <div class="sidebar-content">
        <!-- Navigation Section -->
        <div class="nav-section">
          <div class="nav-section-title">Main Menu</div>
          <mat-nav-list class="sidebar-nav">
            <a mat-list-item 
               routerLink="/dashboard" 
               routerLinkActive="active" 
               class="nav-item">
              <mat-icon matListItemIcon>dashboard</mat-icon>
              <span matListItemTitle>Dashboard</span>
            </a>

            <a mat-list-item 
               routerLink="/tenants" 
               routerLinkActive="active" 
               class="nav-item">
              <mat-icon matListItemIcon>business</mat-icon>
              <span matListItemTitle>Tenants</span>
            </a>

            <a mat-list-item 
               routerLink="/modules" 
               routerLinkActive="active" 
               class="nav-item">
              <mat-icon matListItemIcon>apps</mat-icon>
              <span matListItemTitle>Modules</span>
            </a>
          </mat-nav-list>
        </div>

        <!-- Logout Button at Bottom -->
        <div class="sidebar-footer">
          <button mat-list-item 
                  (click)="logout()" 
                  class="nav-item logout-item">
            <mat-icon matListItemIcon>logout</mat-icon>
            <span matListItemTitle>Logout</span>
          </button>
        </div>
      </div>
    </mat-sidenav>

    <!-- Main Content -->
    <mat-sidenav-content class="main-content">
      <!-- Header -->
      <mat-toolbar class="header-toolbar">
        <div class="header-left">
          <!-- Title removed - now shown in container -->
        </div>
        
        <div class="header-right">
          <div class="user-info">
            <span>{{ currentUser?.firstName }} {{ currentUser?.lastName }}</span>
            <span class="user-role">{{ currentUser?.role }}</span>
          </div>
          <button mat-icon-button color="primary" (click)="openProfileDialog()" matTooltip="Profile Settings" class="profile-button">
            <div class="user-avatar-small">
              <span class="user-initials">{{ getUserInitials() }}</span>
            </div>
          </button>
        </div>
      </mat-toolbar>

      <!-- Page Content -->
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
